<template>
  <div>

   
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";


//import ToastHelper from "../../../helpers/toast.helper";

export default {
  name: "profile",
  components: {
   
  },
  data() {
    return {
    
     
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Utilisateur", route: "profile" },
      { title: "Mon profil" },
    ]);

    this.getMedicinesCount();
  },
  methods: {
    getMedicinesCount: function () {
     
    },

  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
